// Include css
// import './successPopup.css';

// Ant design
import { Modal } from 'antd';

const showFailureModal = obj => {
  // если передано время закрытия используем его (если нет = 5)
  // создаем модальное окно
  return Modal.error(obj);
};

export default showFailureModal;
